import request from '@/utils/request'

const BASE_API_PREFIX = process.env.VUE_APP_BASIC_DATA_API
const VUE_APP_BASIC_DATA_API = process.env.VUE_APP_BASIC_DATA_API_C

/**
 * 查询字典数据
 * @yapi http://10.166.2.23:3000/project/28/interface/api/9880
 */
export const queryDictData = () => {
  return request({
    url: `${BASE_API_PREFIX}baseconfig/getDicData`,
    method: 'GET'
  })
}

/**
 * 查询字典数据
 * @yapi http://10.166.2.23:3000/project/28/interface/api/9880
 */
export const queryCustomerDictData = () => {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}baseconfig/getDicData`,
    method: 'GET'
  })
}

/**
 * 查询企业logo
 */
export const queryLogo = () => {
  return request({
    url: `${BASE_API_PREFIX}protocolManage/noLogin`,
    method: 'POST'
  })
}

/**
 * 查询企业logo
 */
export const queryH5Logo = () => {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}protocolManage/customer/noLogin`,
    method: 'GET'
  })
}

/**
 * 获取可补录的时间
 */
export const checkEffectiveTime = () => {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}personal/h5/checkEffectiveTime`,
    method: 'POST'
  })
}




// WEBPACK FOOTER //
// ./src/api/dict.js